import React from "react";
import { useNavigation } from "@origin-digital/navigation-client-sdk";
import styled from "styled-components";
import { NavLink } from "../NavLink";

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${(p) => p.theme.space.xxlarge}px;

  @media (min-width: ${(p) => p.theme.breakpoints.xl}) {
    gap: ${(p) => p.theme.space.xxxlarge}px;
  }
`;

export const DesktopNav = () => {
  const { data, loading } = useNavigation();
  const navData = data?.children;
  if (loading) {
    return null;
  }
  return (
    <Container>
      {navData?.map((navLink) => (
        <NavLink key={navLink.name} linkConfig={navLink} headlineLink />
      ))}
    </Container>
  );
};
